import { formatDate, getShorterString } from '@bnnvara/helpers';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './styled';

const Subtitle = ({ brand, action, date }) => {
  const showBrandName =
    brand &&
    action !== 'subscribedToBrand' &&
    action !== 'subscribedToFirstBrand';

  if (showBrandName)
    return (
      <S.Subtitle>
        {getShorterString(brand.name, 60)}
        <S.Seperator>·</S.Seperator>

        {formatDate(new Date(date), 'dd-MM-yyyy')}
      </S.Subtitle>
    );

  return null;
};

Subtitle.propTypes = {
  brand: PropTypes.shape(),
  action: PropTypes.string.isRequired,
  date: PropTypes.string,
};
export { Subtitle };
